import {kExerciserImages} from "../../constants/images";
import {renderExerciserLogoTextSize} from "../../controllers/SystemExerciserLogoTextController";

export default function SystemExerciserLogoImage({exerciserLogoSize}) {
    // Used through the app to display exercisers logo image in desktop
    // mode which is the text version of exercisers logo

    // BUILD
    return (
        <div className={`animate-appear ${renderExerciserLogoTextSize(exerciserLogoSize)} mb-[2px]`}>
            <img className={"object-contain h-full"}
                 src={kExerciserImages.logoText}
                 alt="Exercice" />
        </div>
    );
}